import React from 'react';
import './CSS/Mission.css';

// Import images and icons
import missionImage from '../assets/images/mission.png'; // Using existing image
import tickIcon from '../assets/icons/tick.png';

const Mission = () => {
  const missionPoints = [
    "No one-size-fits-all; we solve problems based on real needs.",
    "Honest advice and clear pricing — always.",
    "We treat every job like it matters, because it does.",
    "Our focus is long-term trust, not short-term gain."
  ];

  return (
    <section className="mission-section">
      <div className="container">
        <div className="mission-content">
          {/* Left Column - Content */}
          <div className="mission-left">
            <div className="mission-text-content">
              <h2 className="mission-title">
                Our <span className="text-primary">Mission</span>
              </h2>
              <p className="mission-description">
                To deliver personalized, high-quality services that make life
                easier — from tech repairs to tennis coaching. We are committed
                to making expert support accessible, approachable, and
                affordable.
              </p>
              <ul className="mission-list">
                {missionPoints.map((point, index) => (
                  <li key={index} className="mission-list-item">
                    <img src={tickIcon} alt="tick" className="mission-tick" />
                    <span className="mission-point-text">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="mission-right">
            <div className="mission-image">
              <img src={missionImage} alt="Our Mission" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;